export const state = {
  employees: [],
  systemEmployee: []
}
export default state



// WEBPACK FOOTER //
// ./src/vuex/modules/employees/state.js